/**
 * 토스트 스토어 — 어디서든 `toast.ok('Saved')` 로 호출한다.
 */
import { create } from 'zustand';

let seq = 1;

const useToastStore = create(set => ({
  toasts: [],
  push: ({ type = 'info', title, message, ttl = 4200 }) => {
    const id = seq++;
    set(s => ({ toasts: [...s.toasts, { id, type, title, message }] }));
    if (ttl > 0) {
      setTimeout(() => {
        set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }));
      }, ttl);
    }
    return id;
  },
  remove: id => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })),
  clear: () => set({ toasts: [] })
}));

const push = (type, title, message, ttl) => useToastStore.getState().push({ type, title, message, ttl });

export const toast = {
  ok: (title, message, ttl) => push('ok', title, message, ttl),
  err: (title, message, ttl) => push('err', title, message, ttl ?? 6000),
  info: (title, message, ttl) => push('info', title, message, ttl)
};

export default useToastStore;
